import * as React from 'react'
import { Outlet } from 'react-router-dom'

import {
  DangerousDialogProvider,
  DialogProvider,
  TabsProvider,
} from '@factorialco/deprecated-design-system'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import CrashLogo from 'modules/core/components/CrashLogo'
import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import Form from 'modules/core/components/Form'
import { ActivitiesProvider } from 'modules/core/lib/activities/provider'
import { ClientSideFeatureFlagProvider } from 'modules/core/lib/clientSideFeatureFlags'
import { F0Provider } from 'modules/core/lib/f0-provider'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import legalEntities from 'modules/core/store/collections/legalEntities'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import RootLayout from 'modules/layout/components/RootLayout'
import { LayoutProvider } from 'modules/layout/hooks/useFullscreen'
import locations from 'modules/locations/store/collections/locations'

const LayoutPage = () => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}],
    [employeeGroups, {}],
    [legalEntities, {}],
    [locations, {}],
    [subscriptions, {}],
  ]

  return (
    <ClientSideFeatureFlagProvider>
      <F0Provider>
        <ActivitiesProvider renderActivities={false}>
          <CollectionsBootstrap collections={collections} loadingFallback={null}>
            <LayoutProvider>
              <RootLayout>
                <TabsProvider>
                  <DialogProvider
                    defaultCancelLabel={i18n.t('common.cancel')}
                    defaultConfirmLabel={i18n.t('common.confirm')}
                    Form={Form}
                    ErrorBoundary={ErrorBoundary}
                    errorContent={<CrashLogo compact />}
                  >
                    <DangerousDialogProvider
                      missingLabel={i18n.t('common.missing_field')}
                      selectValue={i18n.t('common.select')}
                      Form={Form}
                      ErrorBoundary={ErrorBoundary}
                      errorContent={<CrashLogo compact />}
                    >
                      <React.Suspense>
                        <Outlet />
                      </React.Suspense>
                    </DangerousDialogProvider>
                  </DialogProvider>
                </TabsProvider>
              </RootLayout>
            </LayoutProvider>
          </CollectionsBootstrap>
        </ActivitiesProvider>
      </F0Provider>
    </ClientSideFeatureFlagProvider>
  )
}

export default LayoutPage
